var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V76H496V16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 76H16V136H496V76Z",
    fill: "#2B4896"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 136H16V196H496V136Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M496 196H16V256H496V196Z",
    fill: "#2B4896"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M496 256H16V316H496V256Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M496 316H16V376H496V316Z",
    fill: "#2B4896"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M496 376H16V436H496V376Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M496 436H16V496H496V436Z",
    fill: "#2B4896"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M236 16H16V316H236V16Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M120.586 191.409L128.502 204.254C95.9742 229.834 115.833 244.961 92.7817 253.149C107.119 237.944 90.5242 236.663 102.604 204.972",
    fill: "#E5B731"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M120.586 191.409L128.502 204.254C95.9742 229.834 115.833 244.961 92.7817 253.149C107.119 237.944 90.5242 236.663 102.604 204.972",
    stroke: "black",
    strokeWidth: 1.85477,
    strokeMiterlimit: 20,
    strokeLinecap: "square"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M114.927 195.05C96.9806 227.193 108.75 244.867 92.7814 253.149Z",
    fill: "#E5B731"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M114.927 195.05C96.9806 227.193 108.75 244.867 92.7814 253.149",
    stroke: "black",
    strokeWidth: 1.85477,
    strokeMiterlimit: 20
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M126 166H141.783L126 260.329L110.218 166H126V260.329Z",
    fill: "#E5B731"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M126 166H141.783L126 260.329L110.218 166H126ZM126 166V260.329",
    stroke: "black",
    strokeWidth: 1.85317,
    strokeMiterlimit: 20
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M126 197.443C141.98 197.443 154.935 183.365 154.935 166C154.935 148.634 141.98 134.557 126 134.557C110.02 134.557 97.0654 148.634 97.0654 166C97.0654 183.365 110.02 197.443 126 197.443Z",
    fill: "#E5B731",
    stroke: "black",
    strokeWidth: 1.85317,
    strokeMiterlimit: 20
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M147.306 153.422C145.465 155.709 144.413 151.707 137.837 151.707C131.26 151.707 130.208 155.995 129.156 155.137C128.104 154.28 134.68 149.134 136.784 148.848C138.889 148.563 144.939 150.849 147.306 153.422ZM139.678 155.995C141.519 157.71 139.941 161.426 138.1 161.426C136.258 161.426 132.839 157.995 134.417 155.709",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M130.998 158.566C131.261 155.136 133.891 154.564 138.1 154.564C142.308 154.564 144.15 157.995 145.728 158.852C143.887 158.852 142.308 155.994 138.1 155.994C133.891 155.994 133.891 155.994 130.998 158.852V158.566ZM131.787 159.424C132.839 157.709 134.154 161.139 137.048 161.139C139.941 161.139 141.519 160.281 143.361 158.852C145.202 157.423 140.73 162.282 137.837 162.282C134.943 162.282 130.998 160.567 131.787 159.424Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M140.73 161.14C144.15 159.139 142.045 156.281 140.73 155.709C141.256 156.281 143.361 159.139 140.73 161.14ZM126 178.291C127.578 178.291 128.104 177.719 130.208 177.719C132.313 177.719 137.311 180.863 140.204 179.72C134.154 182.293 136.521 180.577 126 180.577H124.685L126 178.291ZM141.256 182.293C140.204 180.292 140.467 180.863 138.363 177.719C140.467 179.434 140.993 180.292 141.256 182.293ZM126 185.151C132.576 185.151 131.524 183.722 140.204 179.72C133.891 180.577 132.576 182.864 126 182.864H124.685L126 185.151ZM126 174.575C127.841 174.575 128.367 173.146 130.471 173.146C132.576 173.146 135.469 174.003 136.784 175.146C137.048 175.432 135.995 172.86 133.891 172.574C131.787 172.288 132.576 168.572 130.208 168C130.208 169.144 130.998 168.858 131.261 170.573C131.261 172.002 128.893 172.002 128.367 170.573C128.893 172.86 127.315 172.86 126 172.86",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M126 187.723C124.685 187.723 121.265 188.58 126 188.58C130.735 188.58 127.315 187.723 126 187.723Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUy);
export default __webpack_public_path__ + "static/media/UY.9f267017fa7df6f1bdb178f195ef23b4.svg";
export { ForwardRef as ReactComponent };